<template>
  <div class="template-pie-wrapper">
    <canvas ref="canvas"></canvas>
  </div>
</template>

<script>
import { Doughnut } from 'vue-chartjs';

export default {
  extends: Doughnut,
  name: 'TemplateEventsErrorsPieChart',
  props: {
    templateEvents: {
      type: Array,
      required: true,
    },
  },
  methods: {
    truncate(text, maxLength = 18) {
      return text.length > maxLength ? text.slice(0, maxLength) + '…' : text;
    },
    updateChart() {
      let grouped = this.templateEvents.reduce((acc, err) => {
        if (!err.error || err.error.toUpperCase() === 'SEM ERRO') return acc;
        acc[err.error] = (acc[err.error] || 0) + 1;
        return acc;
      }, {});

      let labels = Object.keys(grouped);
      let data = Object.values(grouped);
      let colors = [];

      if (labels.length === 0) {
        labels = [this.$t('TEMPLATE_EVENTS_REPORT.CHART.NO_ERRORS')];
        data = [1];
        colors = ['#d3d3d3'];
      } else {
        const palette = [
          '#f39c12',
          '#9b59b6',
          '#bada55',
          '#e74c3c',
          '#3498db',
          '#1abc9c',
          '#e67e22',
          '#34495e',
          '#d35400',
          '#7f8c8d',
          '#8e44ad',
          '#2ecc71',
          '#16a085',
          '#c0392b',
          '#95a5a6',
        ];
        colors = palette.slice(0, labels.length);
      }

      this.renderChart(
        {
          labels,
          datasets: [
            {
              data,
              backgroundColor: colors,
            },
          ],
        },
        {
          responsive: true,
          maintainAspectRatio: false,
          cutoutPercentage: 45,
          legend: { display: false },
          tooltips: {
            callbacks: {
              label: (tooltipItem, data) => {
                const dataset = data.datasets[tooltipItem.datasetIndex];
                const label = data.labels[tooltipItem.index] || '';
                const value = dataset.data[tooltipItem.index] || 0;
                return `${label}: ${value}`;
              },
            },
          },
          animation: {
            animateRotate: true,
            animateScale: true,
            onComplete: function () {
              const chart = this.chart;
              const ctx = chart.ctx;
              ctx.font = '14px sans-serif';
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.fillStyle = '#000';

              const dataset = chart.config.data.datasets[0];
              const total = dataset.data.reduce((sum, val) => sum + val, 0);

              chart.getDatasetMeta(0).data.forEach((arc, i) => {
                const value = dataset.data[i];
                const percent = (value / total) * 100;
                if (percent < 5) return;

                const centerX = arc.tooltipPosition().x;
                const centerY = arc.tooltipPosition().y;
                const text = `${percent.toFixed(1)}%`;

                ctx.fillText(text, centerX, centerY);
              });
            },
          },
        }
      );
    },
  },
  watch: {
    templateEvents: {
      handler() {
        this.updateChart();
      },
    },
  },
  mounted() {
    this.updateChart();
  },
};
</script>

<style scoped>
.template-pie-wrapper {
  width: 300px;
  height: 300px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.template-pie-wrapper canvas {
  max-height: 260px;
  max-width: 260px;
}

.template-pie-wrapper .chartjs-legend {
  max-height: 60px;
  overflow-y: auto;
}
</style>
